/**
 * <strong>Purpose:</strong> <br>
 * Provides a mechanism for calling the resize method for a widget which is used in sizing a widget's
 * DOM node when the node is both in the DOM and visible.  This mixin should be mixed into any widget
 * that performs DOM sizing calculations.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * Widget level overrides of resize() should call this.inherited(arguments) after performing all
 * DOM sizing on the parent, so that the children will be sized correctly.
 *
 * @module mw-form/mixins/ResizeMixin
 *
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare"
], function (declare) {
    return declare(null, {
        _isResized: false,

        startup: function () {
            this.inherited(arguments);

            // resize may have been called by this.inherited already since _LayoutWidget calls resize from startup
            if (!this._isResized) {
                // Only call resize if the widget is not hidden or contained inside a hidden ancestor
                var node = {parentNode: this.domNode}; // Start below loop with node as this.domNode
                var doResize = true;
                while ((node = node.parentNode) && (node !== document)) {
                    if ((node.style.display === "none")) {
                        doResize = false;
                        break;
                    }
                }
                if (doResize) {
                    this.resize();
                }
            }
        },

        resize: function () {
            this.inherited(arguments);

            if (this.getChildren) {
                this.getChildren().forEach(function (child) {
                    if (child.resize) {
                        child.resize();
                    }
                }, this);
            }

            this._isResized = true;
        }
    });
});